
export const environment = {
    production: false,
    urlApiFirma: 'https://qa-api-firma.azurewebsites.net/',
    urlCognito: 'https://iccorp-qa.auth.us-east-1.amazoncognito.com/',
    clientCognito: '7athfrtb4i9n43ndfd52435bsd',
    secretCognito: '1h4aj0bpa631rl1mbu2r02faerdo06e5e62ev7mpn1rr6pgfopdn'
  };
  